<template>
  <v-dialog v-model="shown" persistent width="500">
    <v-card class="py-4 px-6">
      <v-card-title class="blue-grey--text text--darken-3 h6 ma-0 pa-0 mb-3">
        {{ $t('ai_features.message_feedback_dialog_title') }}
      </v-card-title>

      <v-card-text class="ma-0 pa-0">
        <p class="my-4 pa-0 blue-grey--text text--darken-1 font-size-16">
          {{ $t('ai_features.message_feedback_dialog_subtitle') }}
        </p>

        <v-textarea
          v-model="feedbackComments"
          auto-grow
          no-resize
          outlined
          rows="3"
          :label="$t('ai_features.message_feedback_comments_label')"
        />
      </v-card-text>
      <v-card-actions class="ma-0 pa-0">
        <v-spacer></v-spacer>
        <v-btn color="blue-grey darken-1" plain @click="handleClose">
          {{ $t('common.button.cancel') }}
        </v-btn>

        <v-btn color="primary" rounded @click="handleSend">
          {{
            feedbackComments
              ? $t('common.button.send')
              : $t('ai_features.message_feedback_sent_without_comments')
          }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'FeedbackDialog',

  props: {
    shown: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      feedbackComments: '',
    }
  },

  methods: {
    handleClose() {
      this.$emit('close')
      this.feedbackComments = ''
    },

    handleSend() {
      this.$emit('send', this.feedbackComments)
      this.feedbackComments = ''
    },
  },
}
</script>
